import { apiGet, apiPost } from '@/lib/api/axios';
import { Notification } from './types';

/**
 * Fetch every active notification for the current user.
 * Route matching happens on the client against this list.
 */
export async function fetchActiveNotifications(): Promise<Notification[]> {
  const response = await apiGet<Notification[]>('/notifications/active', {
    skipTenantPrefix: true,
    meta: {
      background: true,
      context: 'notifications-fetch'
    }
  });
  return response.data;
}

/**
 * Dismiss a notification (temporary)
 */
export async function dismissNotification(notificationId: string): Promise<void> {
  await apiPost(
    `/notifications/dismiss/${notificationId}`,
    {},
    {
      skipTenantPrefix: true,
      meta: {
        background: true,
        context: 'notifications-dismiss'
      }
    }
  );
}

/**
 * Acknowledge a notification (never show again)
 */
export async function acknowledgeNotification(notificationId: string): Promise<void> {
  await apiPost(
    `/notifications/acknowledge/${notificationId}`,
    {},
    {
      skipTenantPrefix: true,
      meta: {
        background: true,
        context: 'notifications-acknowledge'
      }
    }
  );
}

/**
 * Legacy: mark a list of notifications as read
 */
export async function markLegacyNotificationsAsRead(notificationIds: Array<number | string>): Promise<void> {
  // Coerce IDs to integers to satisfy strict backend schema
  const ids = (notificationIds || [])
    .map((id) => (typeof id === 'string' ? Number(id) : id))
    .filter((id): id is number => Number.isInteger(id));

  await apiPost(
    '/notifications/mark-as-read',
    { notification_ids: ids },
    {
      skipTenantPrefix: true,
      headers: {
        'Content-Type': 'application/json'
      },
      meta: {
        background: true,
        context: 'notifications-mark-read'
      }
    }
  );
}
